import styled from 'styled-components';

export interface SectionLabelProps {
  fullwidth?: boolean | any;
  aCenter?: boolean | any;
}

export const SectionLabel = styled.label<SectionLabelProps>`
  font-weight: 500;
  font-size: 14px;
  display: ${props => (props.fullwidth ? 'block' : 'inline-block')};
  margin-bottom: 0;
  padding: 10px 0;
  text-align: ${props => (props.aCenter ? 'center' : '')};
`;

export default SectionLabel;
